import { RowNode, SelectionChangedEvent } from 'ag-grid-community';
import { KatDataGrid } from './data-grid';

class GridSelectionModule {
  grid: KatDataGrid;
  previousSelectionKeys?: string[];

  constructor(grid: KatDataGrid) {
    this.grid = grid;
  }

  getGroupHtmlCheckbox(node: RowNode) {
    return this.grid.querySelector(
      `.dg-group-checkbox[dg-group-id="${node.id}"]`
    );
  }

  // server side data loads in batch so this code handles selection after new rows are rendered
  handleNewRowsSelectionServerside() {
    this.grid.gridOptions.api.forEachNode(node => {
      this.getSelectedGroups().forEach(group => {
        if (node.parent.id === group.id) {
          if (group.isSelected()) {
            node.setSelected(true);
            this.getGroupHtmlCheckbox(node)?.setAttribute('checked', 'true');
          } else {
            node.setSelected(false);
            this.getGroupHtmlCheckbox(node)?.setAttribute('checked', 'false');
          }
        }
      });
    });
  }

  getSelectedGroups() {
    return this.grid.gridOptions.api
      .getRenderedNodes()
      .filter(node => node.group && node.isSelected());
  }

  onRowSelected = () => {
    this.grid._selectedRows = this.grid.gridOptions.api.getSelectedNodes();
  };

  selectDisplayedRows = () => {
    if (
      this.grid.gridOptions.rowSelection === 'single' ||
      this.grid.gridOptions.rowSelection === 'multiple'
    ) {
      this.grid.gridOptions.api.getRenderedNodes().forEach(node => {
        node.setSelected(true);
      });
    }
  };

  deselectAllRows = () => {
    this.grid.gridOptions.api.deselectAll();
    this.grid.querySelectorAll('.dg-group-checkbox').forEach(el => {
      el.setAttribute('checked', 'false');
      el.setAttribute('indeterminate', 'false');
    });
  };

  selectionHasChanged(previousSelectionKeys, currSelection) {
    if (!previousSelectionKeys) {
      return true;
    }
    const prevSelectionHash = previousSelectionKeys.join('');
    const currSelectionHash = currSelection
      .map(s => s[this.grid.primaryKeyField])
      .join('');
    return prevSelectionHash !== currSelectionHash;
  }

  onSelectionChanged = (event: SelectionChangedEvent) => {
    if (
      this.grid.editMode === 'bulk' &&
      event.api.getSelectedNodes().length > 0
    ) {
      this.grid.cancelBulkEdit();
    }

    if (
      this.selectionHasChanged(
        this.previousSelectionKeys,
        event.api.getSelectedRows()
      )
    ) {
      this.previousSelectionKeys = event.api
        .getSelectedRows()
        .map(s => s[this.grid.primaryKeyField]);
      this.grid._selectionChanged.emit({
        selectedRows: event.api.getSelectedRows(),
        selectedNodes: event.api.getSelectedNodes(),
      });
    }
  };
}

export { GridSelectionModule };
